<template>
  <form-section
    :title="$t('ApplicationForm_Row_HuaweiPushNotificationSettingsTitle')"
  >
    <el-form :model="model" :disabled="readonly">
      <el-row>
        <el-col :span="14">
          <form-item
            prop="android_sender_id"
            :label="$t('ApplicationForm_Field_Huawei_App_ID')"
          >
            <el-input v-model="model.huawei_app_id" />
          </form-item>
          <form-item
            prop="new_android_key"
            :label="$t('ApplicationForm_Field_Huawei_App_Secret')"
          >
            <el-input
              :placeholder="
                model.android_key ? $t('ApplicationForm_Field_Change') : ''
              "
              v-model="model.new_android_key"
            />
          </form-item>
        </el-col>
      </el-row>
    </el-form>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import FormItem from '@/common/components/form/FormItem'
export default {
  name: 'PushSettingshHuawei',
  components: { FormItem, FormSection },
  data() {
    return {}
  },
  props: {
    model: {
      required: true,
      default: {
        new_android_key: null
      }
    },
    readonly: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/modules/settings/components/PushSettingsHuawei.vue